<script setup lang="ts">
import { defineProps } from 'vue'
import PartnerTypeTag from '@/components/features/partners/PartnerTypeTag.vue'
import PartnerLogoImage from '@/components/common/ui/PartnerLogoImage.vue'

defineProps(['params'])
</script>

<template>
  <div class="flex gap-2 pb-2 pt-2">
    <PartnerLogoImage :image1920="params.data.image1920" :name="params.data.name" />
    <div class="flex flex-col">
      <p class="text-sm">{{ params.data.name || params.data.partnerId.name }}</p>
      <PartnerTypeTag
        :params="{
          partner: params.data,
        }"
      />
    </div>
  </div>
</template>
